'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var GEO_TOKEN_QUERY = 'geo-location:token:query';
var GEO_REGION_QUERY = 'geo-location:region:query';

exports.GEO_REGION_QUERY = GEO_REGION_QUERY;
exports.GEO_TOKEN_QUERY = GEO_TOKEN_QUERY;
